
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import axios from "axios";

@Options({
  components: {},
})
export default class SideNavigation extends Vue {}
